import axios from 'axios';
import { API_URL } from 'configs'

export const COMPANY_TYPE_REQUEST = 'COMPANY_TYPE_REQUEST'
export const COMPANY_TYPE_SUCCESS = 'COMPANY_TYPE_SUCCESS'
export const COMPANY_TYPE_VALIDATION_ERROR = 'COMPANY_TYPE_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_COMPANY_TYPE_FEILD_VALIDATION_ERROR = "HIDE_COMPANY_TYPE_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_COMPANY_TYPE_LIST = 'REDIRECT_TO_COMPANY_TYPE_LIST'
export const COMPANY_TYPE_GET_SUCCESS = 'COMPANY_TYPE_GET_SUCCESS'
export const COMPANY_TYPE_SERVER_SUCCESS = 'COMPANY_TYPE_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const companyTypeRequest = () => ({
  type: COMPANY_TYPE_REQUEST,
})

export const companyTypeServerListSuccess = () => ({
  type: COMPANY_TYPE_SERVER_SUCCESS,
})

const companyTypeListSuccess = companyTypeList => ({
  type: COMPANY_TYPE_SUCCESS,
  companyTypeList: companyTypeList,
})

const companyTypeFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})

const validationError = notification => ({
  type: COMPANY_TYPE_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const companyTypeAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(companyTypeSuccessNotification(message))
  dispatch(redirectToCompanyTypeList())
}

export const redirectToCompanyTypeList = () => ({
  type: REDIRECT_TO_COMPANY_TYPE_LIST,
})

const getCompanyTypeSuccess = (response, action) => ({
  type: COMPANY_TYPE_GET_SUCCESS,
  record: response,
  actionType: action
})

const companyTypeSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideCompanyTypeValidationError = (feild_key) => ({
  type: HIDE_COMPANY_TYPE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const companyTypeListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(companyTypeRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "company_type/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(companyTypeListSuccess(response.data))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const addCompanyType = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(companyTypeRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "company_type/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        companyTypeAddUpadteSuccess('Company Type Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const updateCompanyType = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(companyTypeRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "company_type/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        companyTypeAddUpadteSuccess('Company Type Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getCompanyTypeById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(companyTypeRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "company_type/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(getCompanyTypeSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const deleteCompanyType = (companyTypeId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(companyTypeRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "company_type/delete/" + companyTypeId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(companyTypeSuccessNotification('Company Type deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(companyTypeFailure(err))
    }
  }
  catch (e) {
    dispatch(companyTypeFailure('Unable to perform action.Something went wrong'))
  }
}   